import React, {useMemo, useState} from "react";
import moment from "moment-timezone";
import {ConfigProvider, message} from "antd";
import DeliveryProviderInvoiceTable from "../../../admin/AdminDeliveryProviderInvoices/DeliveryProviderInvoiceTable/DeliveryProviderInvoiceTable";
import {useRequest} from "../../../utils/hooks";
import {HttpClient} from "../../../http/HttpClient";
import "./delivery-provider-manage-invoices.css";

const DeliveryProviderManageInvoices = () => {
    const [selectedMonth, setSelectedMonth] = useState(moment().subtract(1, "month"));

    const [deliveriesResponse, loadingDeliveries] = useRequest(
        "/api/deliveryProviders/deliveries",
        "POST",
        {
            startDate: selectedMonth.clone().startOf("month").valueOf(),
            endDate: selectedMonth.clone().endOf("month").valueOf(),
            projection: [
                "deliveryId",
                "status",
                "sourceAddress",
                "destinationAddress",
                "price",
                "until",
                "dtstart",
                "companyName",
                "proposalId",
                "orderId",
                "error",
                "statusMessage"
            ],
            pageSize: 1000,
            page: 1
        },
        [selectedMonth],
        !!selectedMonth
    );

    const [monthInvoices, isLoadingMonthInvoices, errorMonthInvoices, refreshMonthInvoices] = useRequest(
        `/api/deliveryProviderInvoice/getMonthInvoices/${selectedMonth.format("MM-YYYY")}`
    );

    const onUploadInvoice = async invoice => {
        const {error} = await HttpClient.safePut("/api/deliveryProviderInvoice/createInvoice", invoice);

        if (error) {
            message.error("יצירת החשבונית נכשלה, אנא נסה שנית מאוחר יותר");
        }

        refreshMonthInvoices();
    };

    return (
        <ConfigProvider direction="rtl">
            <div className="delivery-provider-manage-invoices">
                <DeliveryProviderInvoiceTable
                    deliveries={deliveriesResponse?.deliveries || []}
                    loadingDeliveries={loadingDeliveries}
                    invoices={monthInvoices}
                    selectedMonth={selectedMonth}
                    setSelectedMonth={setSelectedMonth}
                    logsURI={`/api/deliveryProviderInvoiceLog/byMonth/${selectedMonth.format("MM-YYYY")}`}
                    uploadInvoice={onUploadInvoice}
                />
            </div>
        </ConfigProvider>
    );
};

export default DeliveryProviderManageInvoices;
